export default __webpack_public_path__ + "static/media/failure.547b4085.svg";